import script from "./PopularCategoryListingsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./PopularCategoryListingsComponent.vue?vue&type=script&setup=true&lang=js"

import "./PopularCategoryListingsComponent.vue?vue&type=style&index=0&id=00c330ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00c330ba"]])

export default __exports__